var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('n-list',{attrs:{"value":"items","text":"選項","fields":_vm.fields,"items":_vm.items}})}
var staticRenderFns = []

export { render, staticRenderFns }